import { render, staticRenderFns } from "./CommonArticleItem.vue?vue&type=template&id=7430fbcc&"
import script from "./CommonArticleItem.vue?vue&type=script&lang=js&"
export * from "./CommonArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7430fbcc')) {
      api.createRecord('7430fbcc', component.options)
    } else {
      api.reload('7430fbcc', component.options)
    }
    module.hot.accept("./CommonArticleItem.vue?vue&type=template&id=7430fbcc&", function () {
      api.rerender('7430fbcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/CommonArticleItem.vue"
export default component.exports